import styled from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography/Headings'
import Toggle from 'react-toggle'

export const PowerCardsWrapper = styled.div`
  display: flex;
`

export const PowerCycleWrapper = styled.div`
  margin-top: 32px;
`

export const PowerCycleHeader = styled(H1)`
  margin-bottom: 16px;
`

export const PowerCycleSearchWrapper = styled.div`
  margin-bottom: 16px;
`

export const LoadSpan = styled.span`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 700;
`

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const StyledToggle = styled(Toggle)`
  .react-toggle-track {
    background-color: ${theme.colors.duneWarmGrey};
  }

  &:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #000;
  }

  .react-toggle-thumb {
    border-color: ${theme.colors.duneWarmGrey};
  }
`

export const CellColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CellRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const AccessMessage = styled.div`
  display: flex;
`
